import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { DocumentCopiesRequest, DocumentCopiesSearchResponse, DocumentCopyResponse } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/document-copies`;

export const searchDocumentCopies = (
    documentCopiesSearchRequest: any,
    source: CancelTokenSource): Promise<Array<DocumentCopiesSearchResponse>> => {
  return axios
      .post(`${baseUrl}/api/document-copies/search`, documentCopiesSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchCollectiveBills = (
    collectiveBillsRequest: any,
    source: CancelTokenSource): Promise<Array<DocumentCopiesSearchResponse>> => {
  return axios
      .post(`${baseUrl}/api/document-copies/collective-bills/search`, collectiveBillsRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchDocumentCollectiveBills = (
    collectiveBillId: number,
    mandateId: number | undefined,
    source: CancelTokenSource): Promise<Array<DocumentCopiesSearchResponse>> => {

  let formData = new FormData();
  formData.append("mandateId", `${mandateId}`);

  return axios
      .post(`${apiUri}/search/${collectiveBillId}`, formData, {cancelToken: source.token})
      .then(response => response.data);
};


export const documentCopiesOutput = (
    documentCopiesRequest: Partial<DocumentCopiesRequest>,
    source: CancelTokenSource): Promise<Array<DocumentCopyResponse>> => {

  return axios
      .post(apiUri, documentCopiesRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const getDocumentCopyPdfUrl = (pdfId: string, pdfName: string): string => {
  return `${baseUrl}/d66094dd8fb845e7918f6d438e22fcab/${pdfId}/${pdfName}`;
};

export const openDocumentCopyPdf = (pdfId: string, pdfName: string) => {
  window.open(`${baseUrl}/d66094dd8fb845e7918f6d438e22fcab/${pdfId}/${pdfName}`, '_blank')
};
